import React from 'react';
import { Select, Row } from 'antd';
import './index.less';
import ABSIcon from '../../ABSIcon';
import classNames from 'classnames';
import ABSAvatar from '../../ABSAvatar';
import ABSLoading from '../../ABSLoading';
import { ABSSelectView } from '../../ABSSelect/ABSSelectView';
import { IABSSearchViewProps } from '../interface';
import ISearchOption from './ISearchOption';
import ABSComment from '../../ABSComment';

const Option = Select.Option;
const OptGroup = Select.OptGroup;
class ABSSearchView extends React.Component<IABSSearchViewProps, any> {
  renderNotFoundContent = () => {
    const { loading } = this.props;
    if (!loading) {
      return null;
    }
    return <ABSLoading />;
  };

  renderSingle(item: ISearchOption, index: number) {
    const { value, desc, text, avatar } = item;
    if (!value && !text) {
      return null;
    }

    return (
      <Option key={`${value}${index}`} value={value} title={text} className="search-item">
        {avatar ? (
          <ABSAvatar
            imageUrl={avatar}
            size="default"
            className="search-item-left"
          />
        ) : null}
        <div className="search-item-right">
          <Row>{text}</Row>
          <Row className="search-item-right-desc">{desc}</Row>
        </div>
      </Option>
    );
  }

  customOptions() {
    const { searchOptions } = this.props;
    return searchOptions.map((item, index) => {
      const { children, labelName } = item;
      if (children) {
        return (
          <OptGroup label={labelName} key={labelName + index}>
            {
              children.length ? children.map((values, indexs) => this.renderSingle(values, indexs)) 
              : <Option key={`${index}`} className="search-item-nodata" disabled={true}>暂无相关数据</Option>
            }
          </OptGroup>
        );
      }
      return this.renderSingle(item, index);
    });
  }

  render() {
    const {
      placeholder,
      onSearch,
      value,
      onChange,
      className,
      disabled,
      dropdownClassName,
      removeMarginBottom,
      loading,
      style,
      mode,
      title,
      removePaddingLeft,
      required,
      labelWidth,
      contentWidth,
      result,
      defaultValue,
      labelInValue,
      onDeselect,
      isFlex,
      optionLabelProp,
      optionInline,
      noResult = []
    } = this.props;
    let classes, dropdownClasses;
    classes = classNames('abs-search', className);
    dropdownClasses = classNames(
      { 'abs-search-dropdown-fetching': loading },
      { 'abs-search-dropdown-option-inline': optionInline},
      dropdownClassName
    );
    
    return (
    <div className="abs-search-view">
      {mode && noResult.length ? <ABSComment>{'“' + noResult.join('，') + '” 没有找到结果'}</ABSComment> : null}
      <ABSSelectView
        result={result}
        defaultValue={defaultValue}
        showSearch={true}
        value={value}
        placeholder={placeholder}
        notFoundContent={this.renderNotFoundContent()}
        filterOption={false}
        onSearch={onSearch}
        onChange={onChange}
        style={style}
        disabled={disabled}
        className={classes}
        dropdownClassName={dropdownClasses}
        customOptions={this.customOptions()}
        mode={mode}
        title={title}
        required={required}
        removePaddingLeft={removePaddingLeft}
        removeMarginBottom={removeMarginBottom}
        labelWidth={labelWidth}
        contentWidth={contentWidth}
        labelInValue={labelInValue}
        onDeselect={onDeselect}
        isFlex={isFlex}
        optionLabelProp={optionLabelProp || 'title'}
        suffixIcon={
          <ABSIcon
            type="search"
            style={{ color: '#999' }}
          />
        }
      />
    </div>
    );
  }
}

export default ABSSearchView;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSSearch/SearchView/index.tsx